import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import  { ProvinceManipulationView } from "./provinceManipulation-view"

export class ProvinceManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت استان ها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.provinces = ObservableArray.create<province>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new ProvinceManipulationView();
    }
    public getTypeId(): string {
        return "VM-CFA70C55-BD84-4383-8A5E-DAFC04D69834"
    }
    public set provinces(v: ObservableArray<province>) { this._provinces = v; } public get provinces(): ObservableArray<province> { return this._provinces;} private _provinces: ObservableArray<province>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllProvince',{
                FilteringInformation:filteringInformation
            });
            let rowNumber = 1;
            this.provinces.update(...result.Province.map(q=>{
                let r = new province(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.name = q.Name;
                r.sortOrder = q.SortOrder;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestProvinceCreation(){
        let editor = new provinceEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async provinceUpdater(province:province){
        let editor = new provinceEditor(this,new UpdateServerUpdater());
        province.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
}

export class province extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ProvinceManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.sortOrder = 1000;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set sortOrder(v: number) { this._sortOrder = getAsNumber(v,true); } public get sortOrder(): number { return this._sortOrder;} private _sortOrder: number;

    private _typedParent:ProvinceManipulationViewModel;


    cloneTo(province:province){
        province.id = this.id;
        province.name = this.name;
        province.sortOrder = this.sortOrder;
    }

    async edit(){
        this._typedParent.provinceUpdater(this);
    }    
}

interface IServerUpdater{
    execute(province:province):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'استان با موفقیت ثبت شد.';
    }
    async execute(province: province): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateProvince',{
            Name:province.name,
            SortOrder:province.sortOrder
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'استان با موفقیت به روز رسانی شد.';

    }
    async execute(province: province): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/UpdateProvince',{
            Id:province.id,
            Name:province.name,
            SortOrder:province.sortOrder
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class provinceEditor extends province implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ProvinceManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام استان مشخص نشده است.')
        } 
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت استان');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class ProvinceSelectorViewModel extends SelectorBaseViewModel<provinceForSelector>{
    protected async loadData(): Promise<provinceForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllProvince',{});
        return result.Province.map(q=>{
            let result = new provinceForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

class provinceForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
